// client/src/components/agent/actions/interactiveLimits.js
// Límites de Meta para mensajes interactivos. Deben coincidir con
// server/services/interactiveMessage.js (el servidor revalida siempre).
export const LIMITS = {
  BODY: 1024,
  FOOTER: 60,
  BUTTON_TITLE: 20,
  BUTTONS_MAX: 3,
  LIST_BUTTON: 20,
  ROW_TITLE: 24,
  ROW_DESC: 72,
  ROWS_MAX: 10,
  SECTION_TITLE: 24,
};

// Configuración inicial de un mensaje interactivo (botones de respuesta rápida
// con un botón vacío por defecto).
export function emptyInteractive() {
  return {
    header: null, // { type: 'image'|'video'|'document', url }
    body: '',
    footer: null, // string cuando el pie está activo
    action: { type: 'quick_reply', buttons: [{ text: '' }] },
  };
}

// Valida la configuración en el cliente (para habilitar/deshabilitar el envío y
// dar feedback). Devuelve un string de error o null si es válida.
export function validateInteractive(cfg) {
  if (!cfg) return 'Configuración vacía';
  const body = (cfg.body || '').trim();
  if (!body) return 'Escribe el cuerpo del mensaje';
  if (body.length > LIMITS.BODY) return `El cuerpo supera ${LIMITS.BODY} caracteres`;
  if (cfg.footer != null && cfg.footer.length > LIMITS.FOOTER) return `El pie supera ${LIMITS.FOOTER} caracteres`;
  if (cfg.header && !(cfg.header.url || '').trim()) return 'Sube el archivo del encabezado o desactívalo';

  const a = cfg.action || {};
  if (a.type === 'quick_reply') {
    const texts = (a.buttons || []).map((b) => (b.text || '').trim()).filter(Boolean);
    if (!texts.length) return 'Agrega al menos un botón';
    if (texts.length > LIMITS.BUTTONS_MAX) return `Máximo ${LIMITS.BUTTONS_MAX} botones`;
  } else if (a.type === 'url') {
    if (!(a.text || '').trim()) return 'Escribe el texto del botón';
    if (!/^https?:\/\/.+/i.test((a.url || '').trim())) return 'La URL debe empezar por http:// o https://';
  } else if (a.type === 'list') {
    if (!(a.buttonText || '').trim()) return 'Escribe el texto del botón que abre la lista';
    const rows = (a.rows || []).filter((r) => (r.title || '').trim());
    if (!rows.length) return 'Agrega al menos una opción a la lista';
    if (rows.length > LIMITS.ROWS_MAX) return `Máximo ${LIMITS.ROWS_MAX} opciones`;
  } else {
    return 'Elige un tipo de interacción';
  }
  return null;
}
